export default "__VITE_ASSET__7292145a__"